import React from 'react'
import { Actions } from 'src/components/CustomTable/components/Actions'
import { useNavigate } from 'react-router-dom'
import { montaTypes } from 'src/constants/montaType'
import { formatDate } from 'src/utils'
import { CouplePlanningDto } from 'src/dto/couple-planning.dto'
import ROUTES from 'src/constants/routes'

export const useCouplePlanningTableHeader = () => {
  const navigate = useNavigate()

  const tableHeader = [
    {
      property: 'nomeVaca',
      name: 'NOME VACA',
      textAlign: 'center',
      format: (value: string) => value || '-'
    },
    {
      property: 'nomeTouro',
      name: 'NOME TOURO',
      textAlign: 'center',
      format: (value: string) => value || '-'
    },
    {
      property: 'tipoMonta',
      name: 'REPRODUÇÃO',
      format: (value: string) => (value ? montaTypes[value]?.value ?? '-' : '-'),
      textAlign: 'center'
    },
    {
      property: 'dataInicio',
      name: 'DATA COBERTURA',
      format: (value: string) => formatDate(value, false) || '-',
      textAlign: 'center'
    },
    {
      property: 'inseminador',
      name: 'INSEMINADOR',
      format: (value: string) => value || '-',
      textAlign: 'center'
    },
    {
      size: 122,
      property: 'status',
      compoment: (value: CouplePlanningDto) => (
        <Actions onClick={() => navigate(ROUTES.COUPLE_PLANNING.toDetails(value.id))} />
      )
    }
  ]

  return {
    tableHeader
  }
}
